import React from 'react';
import Modal from 'react-bootstrap4-modal';

const CustomModal = (props) => {
    let { details, confirmBtn, cancelBtn, crossBtn, enableBackDrop, modalType, modalHeader, showBtns, modalSize, noOverFLow } = props
    let __modalSize = `${(modalSize === "large") ? "modal-lg" : ''}`
    let __noOverFlow = noOverFLow ? 'hidden' : 'auto'

    const isDanger = modalType === "danger" || modalHeader === "danger";

    return (
        <Modal dialogClassName={__modalSize} visible={props.visibility} onClickBackdrop={enableBackDrop ? cancelBtn.action : null}>
            <div style={{
                borderRadius: '16px',
                border: '1px solid #E2E8F0',
                boxShadow: '0 20px 25px -5px rgba(0,0,0,0.08), 0 8px 10px -6px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                background: '#fff',
                animation: 'scaleIn 0.25s ease'
            }}>
                {/* Header */}
                <div style={{
                    padding: '16px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #F1F5F9',
                    background: isDanger ? '#FEF2F2' : '#fff'
                }}>
                    <h5 style={{
                        fontWeight: '600',
                        fontSize: '15px',
                        color: isDanger ? '#991B1B' : '#0F172A',
                        margin: 0,
                        letterSpacing: '-0.01em'
                    }}>{details.info}</h5>
                    <button
                        type="button"
                        onClick={crossBtn.action}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '20px',
                            color: '#94A3B8',
                            cursor: 'pointer',
                            padding: '4px 8px',
                            borderRadius: '6px',
                            lineHeight: '1',
                            transition: 'color 150ms ease, background 150ms ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => { e.target.style.background = '#F1F5F9'; e.target.style.color = '#475569'; }}
                        onMouseLeave={(e) => { e.target.style.background = 'none'; e.target.style.color = '#94A3B8'; }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                {/* Body */}
                <div style={{
                    padding: '20px 24px',
                    maxHeight: '51.7em',
                    overflowY: __noOverFlow,
                    fontSize: '13px',
                    color: '#475569',
                    lineHeight: '1.6'
                }}>
                    {typeof details.msg === 'string' ? <p style={{fontSize: '14px', margin: 0}}>{details.msg}</p> : details.msg}
                </div>

                {/* Footer */}
                {showBtns && (
                    <div style={{
                        padding: '12px 24px',
                        background: '#F8FAFC',
                        borderTop: '1px solid #F1F5F9',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '8px'
                    }}>
                        <button
                            type="button"
                            onClick={cancelBtn.action}
                            style={{
                                background: '#fff',
                                border: '1px solid #E2E8F0',
                                borderRadius: '8px',
                                padding: '8px 16px',
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#475569',
                                cursor: 'pointer',
                                transition: 'all 150ms ease'
                            }}
                            onMouseEnter={(e) => { e.target.style.borderColor = '#CBD5E1'; e.target.style.background = '#F8FAFC'; }}
                            onMouseLeave={(e) => { e.target.style.borderColor = '#E2E8F0'; e.target.style.background = '#fff'; }}
                        >
                            {cancelBtn.label}
                        </button>
                        <button
                            type="button"
                            onClick={confirmBtn.action}
                            style={{
                                background: isDanger ? '#EF4444' : '#10B981',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '8px 16px',
                                fontSize: '13px',
                                fontWeight: '600',
                                color: '#fff',
                                cursor: 'pointer',
                                transition: 'all 150ms ease',
                                boxShadow: isDanger ? '0 2px 8px rgba(239,68,68,0.25)' : '0 2px 8px rgba(16,185,129,0.25)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-1px)';
                                e.target.style.boxShadow = isDanger ? '0 4px 12px rgba(239,68,68,0.35)' : '0 4px 12px rgba(16,185,129,0.35)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = isDanger ? '0 2px 8px rgba(239,68,68,0.25)' : '0 2px 8px rgba(16,185,129,0.25)';
                            }}
                        >
                            {confirmBtn.label}
                        </button>
                    </div>
                )}
            </div>

        </Modal>
    )
}
export default CustomModal

CustomModal.defaultProps = {
    modalType: 'confirmation',
    visibility: true,
    showBtns: true,
    enableBackDrop: true,
    details: {
        info: 'N/A',
        msg: 'N/A'
    },
    crossBtn: {
        action: null
    },
    confirmBtn: {
        label: 'Confirm',
        action: null
    },
    cancelBtn: {
        label: 'Cancel',
        action: null
    }
}
